import { API } from '~apis/axios/instance';
import { TermOffer } from '~types/company';
import { ResponseBase } from '~types/response';

export interface GetTermOffersResponse extends ResponseBase {
  data: TermOffer;
}

/**
 * USER가 제공 받은 양도 조건을 조회한다.
 * @link https://apollo11.dev.clobe.ai/swagger-ui/index.html#/company-term-controller/getTerm_2
 *
 * @param companyId
 * @returns
 */
export default function getTermOffers(companyId: string) {
  return API.get<GetTermOffersResponse>(`/api/v2/companies/${companyId}/term-offers`);
}
